// Turns recent PREVIEW_* telemetry events into a short, human-readable trace the AI tutor
// can use to ground its answer in what the student actually did in the rendered output -
// e.g. "typed into #message-input, clicked #send-button" - rather than only seeing their
// code and a description of the problem.

const INTERACTION_TYPES = new Set([
  'PREVIEW_CLICK',
  'PREVIEW_INPUT',
  'PREVIEW_SUBMIT',
  'PREVIEW_FOCUS',
  'PREVIEW_SCROLL',
  'PREVIEW_RUNTIME_ERROR',
  'PREVIEW_CONSOLE',
])

function refFor(target) {
  if (!target) return 'an element'
  if (target.id) return `#${target.id}`
  if (target.classes?.length) return `.${target.classes[0]}`
  if (target.tag) return `<${target.tag}>`
  return 'an element'
}

function describeEvent({ type, payload }) {
  const ref = refFor(payload?.target)
  switch (type) {
    case 'PREVIEW_CLICK':
      return `clicked ${ref}`
    case 'PREVIEW_INPUT':
      if (payload?.target?.checked !== undefined) return `toggled ${ref} (checked: ${payload.target.checked})`
      return `typed into ${ref}`
    case 'PREVIEW_SUBMIT':
      return `submitted ${ref}`
    case 'PREVIEW_FOCUS':
      return payload?.focused ? `focused ${ref}` : `left ${ref}`
    case 'PREVIEW_SCROLL':
      return `scrolled to y=${payload?.scrollY}`
    case 'PREVIEW_RUNTIME_ERROR':
      return `saw a runtime error: ${payload?.message}`
    case 'PREVIEW_CONSOLE':
      return `saw console.${payload?.level}: ${payload?.message}`
    default:
      return null
  }
}

// Returns a "- clicked #x\n- typed into #y" style string, or '' if there's nothing recent.
export function summarizeRecentInteractions(events, { maxItems = 8, withinMs = 120000 } = {}) {
  if (!Array.isArray(events) || events.length === 0) return ''
  const now = Date.now()
  const lines = events
    .filter(e => INTERACTION_TYPES.has(e.type) && (now - e.timestamp) <= withinMs)
    .slice(-maxItems)
    .map(describeEvent)
    .filter(Boolean)
  return lines.map(l => `- ${l}`).join('\n')
}

// Returns the payload of the most recent PREVIEW_SNAPSHOT event, or null.
export function getLatestVisualContext(events) {
  if (!Array.isArray(events)) return null
  for (let i = events.length - 1; i >= 0; i--) {
    if (events[i].type === 'PREVIEW_SNAPSHOT') return events[i].payload
  }
  return null
}
